<div class="header list-header d-none d-md-block">
  <h1 class="d-inline-block v-align-middle">{{ title | translate }}</h1>
  <astral-button class="btn-list-header" variant="secondary" type="button" icon="plus" labelKey="CREATE_BTN" (click)="onCreateItem()"></astral-button>
  @if (excelReady) {
    <app-excel-list
      class="btn-list-header"
      [columnDefinition]="excelColumnDefinition"
      [selectedListViewColumns]="selectedColumns"
      [excelContext]="excelContext"
      [filter]="filterState"
      [fileName]="excelFileName"
      [selectedIds]="selectedCompanyIds"
      [affectedItemsCount]="selectedCompanyCount"
      [allSelected]="allCompaniesSelected"
      [totalResults]="totalCompanies"
    ></app-excel-list>
  }
</div>
<div class="header list-header d-flex d-md-none align-items-center">
  <h1 class="w-100">{{ title | translate }}</h1>
  <astral-button class="btn-list-header" variant="secondary" type="button" icon="plus" labelKey="CREATE_BTN" (click)="onCreateItem()"></astral-button>
  @if (excelReady) {
    <app-excel-list
      [columnDefinition]="excelColumnDefinition"
      [selectedListViewColumns]="selectedColumns"
      [excelContext]="excelContext"
      [filter]="filterState"
      [fileName]="excelFileName"
      [selectedIds]="selectedCompanyIds"
      [affectedItemsCount]="selectedCompanyCount"
      [allSelected]="allCompaniesSelected"
      [totalResults]="totalCompanies"
      [isMobile]="true"
    ></app-excel-list>
  }
</div>
<app-filter [filters]="filterDefinition" (change)="onFilterChange($event)" [defaultFilters]="defaultFilters"></app-filter>
@if (itemsSource) {
  <app-multiselect-list-view
    [columnDefinition]="columnDefinition"
    [itemsSource]="itemsSource"
    [contextMenuDefinition]="contextMenuDefinition"
    [menuDefinition]="menuDefinition"
    [externalMenuCommandIds]="sidebarMenuActionCommandIds"
    [preferencesKey]="preferencesKey"
    (onColumnChange)="onColumnChange($event)"
    (selectedItemsChange)="onSelectedCompaniesChange($event)"
    [rememberPagination]="true"
    (menuCommand)="onMenuCommand($event)"
    (rowClick)="onRowClicked($event)"
    [isToolbarSticky]="true"
    >
  </app-multiselect-list-view>
}

<ng-template #bulkSystemSettingsSidebar>
  <app-company-system-settings-bulk
    [dataContext]="sidebarMenuDataContext"
    [useActionWindow]="false"
    (completed)="onBulkSystemSettingsCompleted()"
    (canceled)="closeSidebarMenuAction()"
  ></app-company-system-settings-bulk>
</ng-template>
